import script from "./PaymentModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./PaymentModal.vue?vue&type=script&lang=ts&setup=true"

import "./PaymentModal.vue?vue&type=style&index=0&id=e6ad136c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e6ad136c"]])

export default __exports__